import { Component } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { TotalNutriComponent } from '../total-nutri/total-nutri.component';
import { FoodService } from '../food.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Updatefoodlogs } from '../../../../../models/updatefoodlogs';
import { RouterLink, Router } from '@angular/router';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ToastService } from '../../../../../services/toast.service';

import {
  formatNumber
}
  from '@angular/common';


import { NgIf, DecimalPipe } from '@angular/common';
@Component({
  selector: 'app-edit-food',
  standalone: true,
  imports: [NgIf, DecimalPipe, MatListModule, MatIconModule, TotalNutriComponent, FormsModule, RouterLink, MatTableModule, MatProgressSpinnerModule],
  templateUrl: './edit-food.component.html',
  styleUrl: './edit-food.component.css'
})
export class EditFoodComponent {
  foodId: any;
  foodDetails: any = [];
  foodTotalCal: any = [];
  perGramTotal: any = [];
  qty: any = [];
  memberId: any;
  baseColumns: string[] = ['Ingredients', 'Number of Servings', 'Serving Unit', 'Serving Size', 'Calories', 'Proteins', 'Carbs', 'Fats', 'Fiber', 'isUpf'];
  showCaloriesTooltip: number | null = null;
  tooltipStyle: { top: string; left: string } = { top: '0px', left: '0px' };
  showAlcoholGramsTooltip: number | null = null;
  alcoholGramsTooltipStyle: { top: string; left: string } = { top: '0px', left: '0px' };
  showUnitTooltip: number | null = null;
  unitTooltipStyle: { top: string; left: string } = { top: '0px', left: '0px' };
  private readonly volumeConverter: { [key: string]: number } = {
    grams: 1,
    ounces: 28.35,
    cups: 236.588,
    "fluid ounces": 29.5735,
  };
  optionalColumns: string[] = ['Caffeine', 'Alcohol Grams', 'ABV'];
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource;
  allData: any = [];
  realTotalVal: any = [];
  isLoading: any = 2;
  logDate: string = '';
  logTime: string = '';
  originalLogDate: string = '';
  originalLogTime: string = '';
  navigationState: any = {};
  private readonly DATE_STORAGE_KEY = 'foodLogDateRange';
  constructor(private FoodService: FoodService, private route: ActivatedRoute, private datePipe: DatePipe, private toast: ToastService, private router: Router) {
  }

  ngOnInit(): void {
    this.navigationState = window.history.state?.stateObj || {};
    this.memberId = this.route.snapshot.queryParamMap.get('memberId');
    this.getFoodLogs();
    // this.FoodService.getFoodById(this.route.snapshot.queryParamMap.get('id')).subscribe(response => {    
    //   // this.allData1  = response;
    //   // this.allData  = this.allData1.foodLog;
    //   this.foodDetails = response; 

    //   this.foodDetails =  this.foodDetails.foodLog;
    //   this.setItemOriginalValue(this.foodDetails.foodItems);
    //   //console.log( this.foodDetails);
    //   this.dataSource = this.foodDetails.foodItems;


    //  this.setTotalValue();

    //   // this.perGramTotal={
    //   //   'oneCalories': (this.foodDetails.total.calories/this.foodDetails.serving.size).toFixed(1),
    //   //   'oneProtien': (this.foodDetails.total.protein/this.foodDetails.serving.size).toFixed(1),
    //   //   'oneCarb': (this.foodDetails.total.carbs/this.foodDetails.serving.size).toFixed(1),
    //   //   'oneFat': (this.foodDetails.total.fat/this.foodDetails.serving.size).toFixed(1)
    //   // };

    //   this.realTotalVal={
    //     'cal':this.foodDetails.total.calories,
    //     'pro':this.foodDetails.total.protein,
    //     'carb':this.foodDetails.total.carbs,
    //     'fat':this.foodDetails.total.fat
    //   };

    //  // this.qty=this.foodDetails.serving.quantity;
    //   //console.log(this.perGramTotal);
    //   //this.foodTotalCal
    //   //console.log(this.foodDetails );
    // });
  }

  getFoodLogs() {
    this.FoodService.getFoodById(this.route.snapshot.queryParamMap.get('id')).subscribe(response => {
      // this.allData1  = response;
      // this.allData  = this.allData1.foodLog;
      this.foodDetails = response;

      this.foodDetails = this.foodDetails.foodLog;
      
      // Initialize date and time for editing
      if (this.foodDetails.logTime) {
        const logDateTime = new Date(this.foodDetails.logTime);
        // Format date as YYYY-MM-DD
        const year = logDateTime.getFullYear();
        const month = String(logDateTime.getMonth() + 1).padStart(2, '0');
        const day = String(logDateTime.getDate()).padStart(2, '0');
        this.logDate = `${year}-${month}-${day}`;
        
        // Format time as HH:mm
        const hours = String(logDateTime.getHours()).padStart(2, '0');
        const minutes = String(logDateTime.getMinutes()).padStart(2, '0');
        this.logTime = `${hours}:${minutes}`;
        
        // Store original date and time for comparison (to detect if date is changed)
        this.originalLogDate = this.logDate;
        this.originalLogTime = this.logTime;
      }
      
      this.setItemOriginalValue(this.foodDetails.foodItems);
      console.log(this.foodDetails);
      this.dataSource = this.foodDetails.foodItems;

      this.updateDisplayedColumns();
      this.setTotalValue();

      // this.perGramTotal={
      //   'oneCalories': (this.foodDetails.total.calories/this.foodDetails.serving.size).toFixed(1),
      //   'oneProtien': (this.foodDetails.total.protein/this.foodDetails.serving.size).toFixed(1),
      //   'oneCarb': (this.foodDetails.total.carbs/this.foodDetails.serving.size).toFixed(1),
      //   'oneFat': (this.foodDetails.total.fat/this.foodDetails.serving.size).toFixed(1)
      // };

      this.realTotalVal = {
        'cal': this.foodDetails.total.calories,
        'pro': this.foodDetails.total.protein,
        'carb': this.foodDetails.total.carbs,
        'fat': this.foodDetails.total.fat
      };

      // this.qty=this.foodDetails.serving.quantity;
      //console.log(this.perGramTotal);
      //this.foodTotalCal
      //console.log(this.foodDetails );
    });
  }

  setItemOriginalValue(data: any) {
    for (let i = 0; i < data.length; i++) {
      // Store per-serving base values (backend values are per-serving)
      this.allData[i] = [];
      this.allData[i].push({
        'qty': data[i].serving.quantity,
        'unit': data[i].serving.unit,
        'size': parseFloat(data[i].serving.size) || 1,
        'cal': parseFloat(data[i].nutrition.calories) || 0,
        'pro': parseFloat(data[i].nutrition.protein) || 0,
        'carbs': parseFloat(data[i].nutrition.carbs) || 0,
        'fat': parseFloat(data[i].nutrition.fat) || 0,
        'fiber': parseFloat(data[i].nutrition.fiber) || 0,
        'caffeine': parseFloat(data[i].nutrition.caffeine) || 0,
        'alcoholGrams': parseFloat(data[i].nutrition.alcoholGrams) || 0
      });
      // Calculate display values (per-serving × qty) - like original behavior
      this.calculateVal(i);
    }
  }
  setTotalValue() {
    this.foodTotalCal = {
      'totalCalories': this.foodDetails.total.calories,
      'totalProteins': this.foodDetails.total.protein,
      'totalCarbs': this.foodDetails.total.carbs,
      'totalFats': this.foodDetails.total.fat,
      'totalFiber': this.foodDetails.total.fiber || 0
    };
  }
  getDate(selectedTime: any) {
    const timeParts = selectedTime.split(':');
    const selectedDate = new Date();
    selectedDate.setHours(parseInt(timeParts[0], 10));
    selectedDate.setMinutes(parseInt(timeParts[1], 10));
    return this.datePipe.transform(selectedDate, 'hh:mm a');
  }

  updateFoodLog() {
    if (!this.hasIngredients()) {
      this.toast.errorMessage('Please add at least one ingredient before updating.');
      return;
    }
    // Create a deep copy to avoid mutating the original foodDetails
    let food: any = JSON.parse(JSON.stringify(this.foodDetails));
    let qty: any;
    
    // Update food log name (already bound via ngModel, but ensure it's in the copy)
    if (this.foodDetails.name) {
      food.name = this.foodDetails.name;
    }
    
    // Update notes, mealType, and mealLocation if they exist
    if (this.foodDetails.notes !== undefined) {
      food.notes = this.foodDetails.notes;
    }
    if (this.foodDetails.mealType !== undefined) {
      food.mealType = this.foodDetails.mealType;
    }
    if (this.foodDetails.mealLocation !== undefined) {
      food.mealLocation = this.foodDetails.mealLocation;
    }
    
    // Update date and time - send as-is without timezone conversion
    if (this.logDate && this.logTime) {
      // Combine date and time as string without timezone conversion
      // Format: YYYY-MM-DDTHH:mm:ss (preserve user's entered date/time exactly)
      const [year, month, day] = this.logDate.split('-');
      const [hours, minutes] = this.logTime.split(':');
      
      // Format as ISO-like string but without timezone conversion
      // This preserves the exact date/time the user entered
      food.logTime = `${year}-${month}-${day}T${hours}:${minutes}:00`;
      
      // Check if date has been changed - if yes, send previous date and message to backend
      if (this.originalLogDate && (this.logDate !== this.originalLogDate || this.logTime !== this.originalLogTime)) {
        // Get the original date-time from foodDetails.logTime (the previous date)
        // Keep original format as-is without conversion
        food.oldDate = this.foodDetails.logTime;
        
        console.log('Date changed detected:', {
          oldDate: food.oldDate,
          newDate: food.logTime,
          userEnteredDate: this.logDate,
          userEnteredTime: this.logTime
        });
      }
    } else if (this.foodDetails.logTime) {
      // If date/time wasn't edited, keep the original logTime as-is
      food.logTime = this.foodDetails.logTime;
    }
    
    // Convert nutrition values from displayed totals to per-serving values for backend
    // Displayed values are: perServingBase × sizeScaleFactor × quantity
    // Backend expects: per-serving values (for 1 serving at the current size)
    // So we divide by quantity to get per-serving values
    this.isLoading = 1;

    for (let i = 0; i < food.foodItems.length; i++) {
      // Get the quantity
      qty = Number(food.foodItems[i].serving.quantity) || 1;

      let calories = Number(food.foodItems[i].nutrition.calories) || 0;
      let protein = Number(food.foodItems[i].nutrition.protein) || 0;
      let carbs = Number(food.foodItems[i].nutrition.carbs) || 0;
      let fat = Number(food.foodItems[i].nutrition.fat) || 0;
      let fiber = Number(food.foodItems[i].nutrition.fiber) || 0;
      let caffeine = Number(food.foodItems[i].nutrition.caffeine) || 0;
      let alcoholGrams = Number(food.foodItems[i].nutrition.alcoholGrams) || 0;

      // Divide by quantity to get per-serving values (NO unitVal division!)
      if (qty > 0) {
        calories = calories / qty;
        protein = protein / qty;
        carbs = carbs / qty;
        fat = fat / qty;
        fiber = fiber / qty;
        caffeine = caffeine / qty;
        alcoholGrams = alcoholGrams / qty;
      }

      food.foodItems[i].nutrition.calories = this.roundTo(calories, 4);
      food.foodItems[i].nutrition.protein = this.roundTo(protein, 4);
      food.foodItems[i].nutrition.carbs = this.roundTo(carbs, 4);
      food.foodItems[i].nutrition.fat = this.roundTo(fat, 4);
      food.foodItems[i].nutrition.fiber = this.roundTo(fiber, 4);
      food.foodItems[i].nutrition.caffeine = this.roundTo(caffeine, 4);
      food.foodItems[i].nutrition.alcoholGrams = this.roundTo(alcoholGrams, 4);
      food.foodItems[i].nutrition.alcoholAbv = this.foodDetails.foodItems[i].nutrition?.alcoholAbv || 0;
      food.foodItems[i].nutrition.isAlcoholic = this.foodDetails.foodItems[i].nutrition?.isAlcoholic || false;

      // Preserve flags
      food.foodItems[i].isUpf = this.foodDetails.foodItems[i].isUpf || false;
    }
    
    // Calculate totals from the displayed values (before conversion to per-serving)
    let totalNutri = this.getTotalNutri(this.foodDetails.foodItems);
    
    // Store totals based on the original displayed values (before conversion)
    food.total.calories = parseFloat(totalNutri[0].toFixed(1));
    food.total.protein = parseFloat(totalNutri[1].toFixed(1));
    food.total.carbs = parseFloat(totalNutri[2].toFixed(1));
    food.total.fat = parseFloat(totalNutri[3].toFixed(1));
    food.total.fiber = parseFloat(totalNutri[4].toFixed(1));

    // Calculate and include beverage totals (caffeine, alcohol)
    let totalCaffeine = 0;
    let totalAlcoholGrams = 0;
    let maxAlcoholAbv = 0;
    let isAlcoholic = false;
    for (let i = 0; i < this.foodDetails.foodItems.length; i++) {
      totalCaffeine += this.foodDetails.foodItems[i].nutrition?.caffeine || 0;
      totalAlcoholGrams += this.foodDetails.foodItems[i].nutrition?.alcoholGrams || 0;
      const abv = this.foodDetails.foodItems[i].nutrition?.alcoholAbv || 0;
      if (abv > maxAlcoholAbv) {
        maxAlcoholAbv = abv;
      }
      if (this.foodDetails.foodItems[i].nutrition?.isAlcoholic) {
        isAlcoholic = true;
      }
    }
    food.total.caffeine = parseFloat(totalCaffeine.toFixed(1));
    food.total.alcoholGrams = parseFloat(totalAlcoholGrams.toFixed(1));
    food.total.alcoholAbv = parseFloat(maxAlcoholAbv.toFixed(1));
    food.total.isAlcoholic = isAlcoholic;
    
    // Ensure all food items have proper numeric values (after conversion)
    for (let i = 0; i < food.foodItems.length; i++) {
      food.foodItems[i].nutrition.calories = this.roundTo(food.foodItems[i].nutrition.calories, 4);
      food.foodItems[i].nutrition.protein = this.roundTo(food.foodItems[i].nutrition.protein, 4);
      food.foodItems[i].nutrition.carbs = this.roundTo(food.foodItems[i].nutrition.carbs, 4);
      food.foodItems[i].nutrition.fat = this.roundTo(food.foodItems[i].nutrition.fat, 4);
    }
    
    console.log('Sending to backend:', JSON.stringify(food, null, 2));
    this.FoodService.updateFoodLog(food).subscribe(response => {
      this.isLoading = 2;
      if (response == 1) {
        this.toast.errorMessage('Some exception occurred. Please try again!');
        // Reload data on error to restore original values
        this.getFoodLogs();
      } else {
        this.toast.successMessage('Food logs updated successfully.');
        // Update local foodDetails with the response if available, otherwise keep current values
        const responseData = response as any;
        if (responseData && responseData.foodLog) {
          this.foodDetails = responseData.foodLog;
          // Re-initialize date and time
          if (this.foodDetails.logTime) {
            const logDateTime = new Date(this.foodDetails.logTime);
            const year = logDateTime.getFullYear();
            const month = String(logDateTime.getMonth() + 1).padStart(2, '0');
            const day = String(logDateTime.getDate()).padStart(2, '0');
            this.logDate = `${year}-${month}-${day}`;
            const hours = String(logDateTime.getHours()).padStart(2, '0');
            const minutes = String(logDateTime.getMinutes()).padStart(2, '0');
            this.logTime = `${hours}:${minutes}`;
            
            // Update original date and time to the new values after successful update
            this.originalLogDate = this.logDate;
            this.originalLogTime = this.logTime;
          }
          // Recalculate and update dataSource
          this.setItemOriginalValue(this.foodDetails.foodItems);
          this.dataSource = new MatTableDataSource(this.foodDetails.foodItems);
          this.setTotalValue();
        }
        // Navigate back to member dashboard after successful update
        setTimeout(() => {
          this.navigateToDashboard();
        }, 1500);
      }
      // Don't call getFoodLogs() here as it reloads old data - use response data instead
    });
  }

  changeServingSize(data: any) {
    let val = data.target.value;
    this.foodDetails.total.calories = (this.perGramTotal.oneCalories * val).toFixed(1);
    this.foodDetails.total.protein = (this.perGramTotal.oneProtien * val).toFixed(1);
    this.foodDetails.total.carbs = (this.perGramTotal.oneCarb * val).toFixed(1);
    this.foodDetails.total.fat = (this.perGramTotal.oneFat * val).toFixed(1);
    this.setTotalValue();
  }

  changeServingNo(data: any) {
    let val = data.target.value;
    if (val > 0) {
      let cal = this.foodDetails.total.calories / this.qty;
      let pro = this.foodDetails.total.protein / this.qty;
      let carb = this.foodDetails.total.carbs / this.qty;
      let fat = this.foodDetails.total.fat / this.qty;

      this.foodDetails.total.calories = (cal * val).toFixed(1);
      this.foodDetails.total.protein = (pro * val).toFixed(1);
      this.foodDetails.total.carbs = (carb * val).toFixed(1);
      this.foodDetails.total.fat = (fat * val).toFixed(1);
      this.qty = val;
      this.setTotalValue();
    }
  }

  changeServingValue(data: any, index: any, type: any) {
    const baseData = this.allData[index][0];  // Per-serving base values
    let val = parseFloat(data.target.value);

    if (val < 0) {
      val = 1;
    }

    if (val > 0) {
      // type == 1: quantity change, type == 2: size change
      if (type == 1) {
        this.foodDetails.foodItems[index].serving.quantity = val;
      } else if (type == 2) {
        this.foodDetails.foodItems[index].serving.size = val;
      }

      // Recalculate table values: per-serving × sizeScale × qty
      const sizeScaleFactor = parseFloat(this.foodDetails.foodItems[index].serving.size) / baseData.size;
      const qty = parseFloat(this.foodDetails.foodItems[index].serving.quantity) || 1;

      const proteinValue = parseFloat((baseData.pro * sizeScaleFactor * qty).toFixed(1));
      this.foodDetails.foodItems[index].nutrition.protein = proteinValue;

      const carbsValue = parseFloat((baseData.carbs * sizeScaleFactor * qty).toFixed(1));
      this.foodDetails.foodItems[index].nutrition.carbs = carbsValue;

      const fatValue = parseFloat((baseData.fat * sizeScaleFactor * qty).toFixed(1));
      this.foodDetails.foodItems[index].nutrition.fat = fatValue;

      const fiberValue = parseFloat((baseData.fiber * sizeScaleFactor * qty).toFixed(1));
      this.foodDetails.foodItems[index].nutrition.fiber = fiberValue;

      const caffeineValue = parseFloat((baseData.caffeine * sizeScaleFactor * qty).toFixed(1));
      this.foodDetails.foodItems[index].nutrition.caffeine = caffeineValue;

      const alcoholGramsValue = parseFloat((baseData.alcoholGrams * sizeScaleFactor * qty).toFixed(1));
      this.foodDetails.foodItems[index].nutrition.alcoholGrams = alcoholGramsValue;

      // Recalculate calories from macronutrients (including scaled alcoholGrams)
      const calculatedCalories = this.calculateCaloriesFromMacros(proteinValue, carbsValue, fatValue, alcoholGramsValue);
      this.foodDetails.foodItems[index].nutrition.calories = parseFloat(calculatedCalories.toFixed(1));

      // Recalculate totals (sum of table values)
      let totalNutri = this.getTotalNutri(this.foodDetails.foodItems);
      this.foodDetails.total.calories = parseFloat(totalNutri[0].toFixed(1));
      this.foodDetails.total.protein = parseFloat(totalNutri[1].toFixed(1));
      this.foodDetails.total.carbs = parseFloat(totalNutri[2].toFixed(1));
      this.foodDetails.total.fat = parseFloat(totalNutri[3].toFixed(1));
      this.foodDetails.total.fiber = parseFloat(totalNutri[4].toFixed(1));

      this.setTotalValue();
    }
  }

  getPerServe(allFood: any, divideBy: any) {
    //let size = allFood.qty;  
    let cal = allFood.cal / divideBy;
    let pro = allFood.pro / divideBy;
    let carb = allFood.carbs / divideBy;
    let fat = allFood.fat / divideBy;

    return [cal, pro, carb, fat];
  }

  getNutre(cal: any, pro: any, carb: any, fat: any, val: any, value: any, allFood: any, unit: any) {
    let currentCal = (cal * val * value - allFood.cal) * unit;
    let currentPro = (pro * val * value - allFood.pro) * unit;
    let currentCarb = (carb * val * value - allFood.carbs) * unit;
    let currentFat = (fat * val * value - allFood.fat) * unit;
    return [currentCal, currentPro, currentCarb, currentFat];
  }

  getTotalNutri(data: any) {
    let totalCal = 0;
    let totalPro = 0;
    let totalCarb = 0;
    let totalFat = 0;
    let totalFiber = 0;

    for (let i = 0; i < data.length; i++) {
      // Table values are already totals (per-serving × qty), just sum them
      totalCal += parseFloat(data[i].nutrition.calories) || 0;
      totalPro += parseFloat(data[i].nutrition.protein) || 0;
      totalCarb += parseFloat(data[i].nutrition.carbs) || 0;
      totalFat += parseFloat(data[i].nutrition.fat) || 0;
      totalFiber += parseFloat(data[i].nutrition.fiber) || 0;
    }

    return [totalCal, totalPro, totalCarb, totalFat, totalFiber];
  }


  calculateVal(index: any) {
    const data = this.allData[index][0];  // Per-serving base values
    const qty = this.foodDetails.foodItems[index].serving.quantity || 1;

    // Calculate: per-serving value × quantity
    const proteinValue = parseFloat((data.pro * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.protein = proteinValue;

    const carbsValue = parseFloat((data.carbs * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.carbs = carbsValue;

    const fatValue = parseFloat((data.fat * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.fat = fatValue;

    const fiberValue = parseFloat((data.fiber * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.fiber = fiberValue;

    const caffeineValue = parseFloat((data.caffeine * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.caffeine = caffeineValue;

    const alcoholGramsValue = parseFloat((data.alcoholGrams * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.alcoholGrams = alcoholGramsValue;

    // Recalculate calories from macronutrients (using scaled alcoholGrams)
    const calculatedCalories = this.calculateCaloriesFromMacros(proteinValue, carbsValue, fatValue, alcoholGramsValue);
    this.foodDetails.foodItems[index].nutrition.calories = parseFloat(calculatedCalories.toFixed(1));

    return 1;
  }

  changeNoServing(event: any, index: any, type: any) {
    const data = this.allData[index][0];  // Per-serving base values
    let currentVal = event.target.value;

    // type == 1: quantity change, type == 2: size change, type == 3: unit change
    if (type == 1) {
      this.foodDetails.foodItems[index].serving.quantity = currentVal;
    } else if (type == 2) {
      this.foodDetails.foodItems[index].serving.size = currentVal;
    } else if (type == 3) {
      this.foodDetails.foodItems[index].serving.unit = currentVal;
    }

    // Recalculate table values: per-serving × sizeScale × qty
    const sizeScaleFactor = parseFloat(this.foodDetails.foodItems[index].serving.size) / data.size;
    const qty = parseFloat(this.foodDetails.foodItems[index].serving.quantity) || 1;

    const proteinValue = parseFloat((data.pro * sizeScaleFactor * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.protein = proteinValue;

    const carbsValue = parseFloat((data.carbs * sizeScaleFactor * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.carbs = carbsValue;

    const fatValue = parseFloat((data.fat * sizeScaleFactor * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.fat = fatValue;

    const fiberValue = parseFloat((data.fiber * sizeScaleFactor * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.fiber = fiberValue;

    const caffeineValue = parseFloat((data.caffeine * sizeScaleFactor * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.caffeine = caffeineValue;

    const alcoholGramsValue = parseFloat((data.alcoholGrams * sizeScaleFactor * qty).toFixed(1));
    this.foodDetails.foodItems[index].nutrition.alcoholGrams = alcoholGramsValue;

    // Recalculate calories from macronutrients (using scaled alcoholGrams)
    const calculatedCalories = this.calculateCaloriesFromMacros(proteinValue, carbsValue, fatValue, alcoholGramsValue);
    this.foodDetails.foodItems[index].nutrition.calories = parseFloat(calculatedCalories.toFixed(1));

    // Recalculate totals (sum of table values, which are already totals)
    let totalNutri = this.getTotalNutri(this.foodDetails.foodItems);

    this.foodDetails.total.calories = parseFloat(totalNutri[0].toFixed(1));
    this.foodDetails.total.protein = parseFloat(totalNutri[1].toFixed(1));
    this.foodDetails.total.carbs = parseFloat(totalNutri[2].toFixed(1));
    this.foodDetails.total.fat = parseFloat(totalNutri[3].toFixed(1));
    this.foodDetails.total.fiber = parseFloat(totalNutri[4].toFixed(1));
    this.setTotalValue();
  }

  // Handler for ingredient name change
  changeIngredientName(event: any, index: any) {
    this.foodDetails.foodItems[index].name = event.target.value;
  }

  // Add a new empty ingredient row
  addIngredient() {
    if (!this.foodDetails || !this.foodDetails.foodItems) {
      this.foodDetails = {
        ...this.foodDetails,
        foodItems: []
      };
    }

    // Create a new empty ingredient with default values
    const newIngredient = {
      name: '',
      isNew: true,
      serving: {
        quantity: 1,
        unit: 'grams',
        size: 1
      },
      nutrition: {
        calories: 0,
        protein: 0,
        carbs: 0,
        fat: 0
      }
    };

    // Add to foodItems array
    this.foodDetails.foodItems.push(newIngredient);

    // Add to allData array for calculation logic
    const newIndex = this.foodDetails.foodItems.length - 1;
    this.allData[newIndex] = [];
    this.allData[newIndex].push({
      'qty': newIngredient.serving.quantity,
      'unit': newIngredient.serving.unit,
      'size': newIngredient.serving.size,
      'cal': newIngredient.nutrition.calories,
      'pro': newIngredient.nutrition.protein,
      'carbs': newIngredient.nutrition.carbs,
      'fat': newIngredient.nutrition.fat
    });

    // Update dataSource to refresh the table
    this.dataSource = new MatTableDataSource(this.foodDetails.foodItems);

    // Recalculate totals and ensure they are numeric values
    let totalNutri = this.getTotalNutri(this.foodDetails.foodItems);
    this.foodDetails.total.calories = parseFloat(totalNutri[0].toFixed(1));
    this.foodDetails.total.protein = parseFloat(totalNutri[1].toFixed(1));
    this.foodDetails.total.carbs = parseFloat(totalNutri[2].toFixed(1));
    this.foodDetails.total.fat = parseFloat(totalNutri[3].toFixed(1));
    this.foodDetails.total.fiber = parseFloat(totalNutri[4].toFixed(1));
    this.setTotalValue();
  }

  // Delete an ingredient row
  deleteIngredient(index: number) {
    if (this.foodDetails && this.foodDetails.foodItems && index >= 0 && index < this.foodDetails.foodItems.length) {
      // Remove from foodItems array
      this.foodDetails.foodItems.splice(index, 1);

      // Remove from allData array
      this.allData.splice(index, 1);

      // Update dataSource to refresh the table
      this.dataSource = new MatTableDataSource(this.foodDetails.foodItems);

      // Recalculate totals
      let totalNutri = this.getTotalNutri(this.foodDetails.foodItems);
      this.foodDetails.total.calories = parseFloat(totalNutri[0].toFixed(1));
      this.foodDetails.total.protein = parseFloat(totalNutri[1].toFixed(1));
      this.foodDetails.total.carbs = parseFloat(totalNutri[2].toFixed(1));
      this.foodDetails.total.fat = parseFloat(totalNutri[3].toFixed(1));
      this.foodDetails.total.fiber = parseFloat(totalNutri[4].toFixed(1));
      this.setTotalValue();
    }
  }

  // Handler for food name change
  onFoodNameChange(value: string) {
    if (this.foodDetails) {
      this.foodDetails.name = value;
      console.log('Food name changed to:', value);
    }
  }

  // Handler for date change
  onDateChange(value: string) {
    this.logDate = value;
    console.log('Date changed to:', value);
  }

  // Handler for time change
  onTimeChange(value: string) {
    this.logTime = value;
    console.log('Time changed to:', value);
  }

  hasIngredients(): boolean {
    return Array.isArray(this.foodDetails?.foodItems) && this.foodDetails.foodItems.length > 0;
  }

  // Calculate calories from macronutrients
  // Formula: Calories = (Protein × 4) + (Carbs × 4) + (Fat × 9) + (Alcohol × 7)
  calculateCaloriesFromMacros(protein: number, carbs: number, fat: number, alcoholGrams: number = 0): number {
    const proteinCalories = (parseFloat(protein.toString()) || 0) * 4;
    const carbsCalories = (parseFloat(carbs.toString()) || 0) * 4;
    const fatCalories = (parseFloat(fat.toString()) || 0) * 9;
    const alcoholCalories = (parseFloat(alcoholGrams.toString()) || 0) * 7;
    return proteinCalories + carbsCalories + fatCalories + alcoholCalories;
  }

  // Handler for direct nutrition value changes
  changeNutritionValue(event: any, index: any, nutritionType: string) {
    const value = parseFloat(event.target.value) || 0;

    if (nutritionType === 'protein') {
      this.foodDetails.foodItems[index].nutrition.protein = value;
    } else if (nutritionType === 'carbs') {
      this.foodDetails.foodItems[index].nutrition.carbs = value;
    } else if (nutritionType === 'fat') {
      this.foodDetails.foodItems[index].nutrition.fat = value;
    } else if (nutritionType === 'fiber') {
      this.foodDetails.foodItems[index].nutrition.fiber = value;
    } else if (nutritionType === 'alcoholGrams') {
      this.foodDetails.foodItems[index].nutrition.alcoholGrams = value;
    }

    // Recalculate calories for this ingredient based on macronutrients
    const protein = parseFloat(this.foodDetails.foodItems[index].nutrition.protein) || 0;
    const carbs = parseFloat(this.foodDetails.foodItems[index].nutrition.carbs) || 0;
    const fat = parseFloat(this.foodDetails.foodItems[index].nutrition.fat) || 0;
    const alcoholGrams = this.foodDetails.foodItems[index].nutrition?.alcoholGrams || 0;
    const calculatedCalories = this.calculateCaloriesFromMacros(protein, carbs, fat, alcoholGrams);
    this.foodDetails.foodItems[index].nutrition.calories = parseFloat(calculatedCalories.toFixed(1));

    // Recalculate totals and ensure they are numeric values
    let totalNutri = this.getTotalNutri(this.foodDetails.foodItems);
    this.foodDetails.total.calories = parseFloat(totalNutri[0].toFixed(1));
    this.foodDetails.total.protein = parseFloat(totalNutri[1].toFixed(1));
    this.foodDetails.total.carbs = parseFloat(totalNutri[2].toFixed(1));
    this.foodDetails.total.fat = parseFloat(totalNutri[3].toFixed(1));
    this.foodDetails.total.fiber = parseFloat(totalNutri[4].toFixed(1));
    this.setTotalValue();
  }

  goBack(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.navigateToDashboard();
  }

  private navigateToDashboard(): void {
    const storedRange = this.getStoredDateRange();
    const fallbackDate = this.navigationState?.anchorDate || this.logDate || null;
    const nutritionStart = this.navigationState?.nutritionStartDate || storedRange.fromDt || fallbackDate;
    const nutritionEnd = this.navigationState?.nutritionEndDate || storedRange.toDt || fallbackDate;
    const navigationExtras = {
      queryParams: { memberId: this.memberId },
      state: {
        stateObj: {
          selectedMainTab: this.navigationState?.selectedMainTab || 'lifestyle',
          selectedLifestyleTab: this.navigationState?.selectedLifestyleTab || 'nutrition',
          nutritionStartDate: nutritionStart,
          nutritionEndDate: nutritionEnd,
          selectedNutritionType: this.navigationState?.selectedNutritionType || this.foodDetails?.mealType || null,
          selectedFoodLogId: this.navigationState?.selectedFoodLogId || this.route.snapshot.queryParamMap.get('id')
        }
      }
    };
    this.router.navigate(['/member-dashboard'], navigationExtras);
  }

  private getStoredDateRange(): { fromDt: string | null; toDt: string | null } {
    try {
      const stored = localStorage.getItem(this.DATE_STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        return {
          fromDt: parsed?.fromDt ?? null,
          toDt: parsed?.toDt ?? null
        };
      }
    } catch {
      // ignore parse errors
    }
    return { fromDt: null, toDt: null };
  }

  private roundTo(value: number, decimals: number = 4): number {
    if (!isFinite(value)) {
      return 0;
    }
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
  }

  updateDisplayedColumns(): void {
    // Start with base columns
    let columns = [...this.baseColumns];

    // Check each optional column to see if any ingredient has a value
    if (this.foodDetails?.foodItems) {
      for (const col of this.optionalColumns) {
        if (this.hasAnyValueForColumn(col)) {
          columns.push(col);
        }
      }
    }

    // Always add Actions at the end
    columns.push('Actions');
    this.displayedColumns = columns;
  }

  hasAnyValueForColumn(column: string): boolean {
    if (!this.foodDetails?.foodItems) return false;

    return this.foodDetails.foodItems.some((item: any) => {
      switch (column) {
        case 'Caffeine':
          return item.nutrition?.caffeine != null && item.nutrition.caffeine !== 0;
        case 'Alcohol Grams':
          return item.nutrition?.alcoholGrams != null && item.nutrition.alcoholGrams !== 0;
        case 'ABV':
          return item.nutrition?.alcoholAbv != null && item.nutrition.alcoholAbv !== 0;
        default:
          return false;
      }
    });
  }

  toggleCaloriesTooltip(event: MouseEvent, index: number): void {
    if (this.showCaloriesTooltip === index) {
      this.showCaloriesTooltip = null;
    } else {
      const target = event.currentTarget as HTMLElement;
      const rect = target.getBoundingClientRect();
      this.tooltipStyle = {
        top: (rect.bottom + 8) + 'px',
        left: (rect.left + rect.width / 2) + 'px'
      };
      this.showCaloriesTooltip = index;
    }
  }

  hideCaloriesTooltip(): void {
    this.showCaloriesTooltip = null;
  }

  toggleUnitTooltip(event: MouseEvent, index: number): void {
    if (this.showUnitTooltip === index) {
      this.showUnitTooltip = null;
    } else {
      const target = event.currentTarget as HTMLElement;
      const rect = target.getBoundingClientRect();
      this.unitTooltipStyle = {
        top: (rect.bottom + 8) + 'px',
        left: (rect.left + rect.width / 2) + 'px'
      };
      this.showUnitTooltip = index;
    }
  }

  // Calculate alcohol grams from ABV using formula: volumeMl × (ABV / 100) × 0.789
  calculateAlcoholGramsFromAbv(servingSize: number, servingUnit: string, abv: number): number {
    const unitKey = (servingUnit || 'grams').toLowerCase();
    const volumeMl = (servingSize || 0) * (this.volumeConverter[unitKey] || 1);
    return volumeMl * (abv / 100) * 0.789;
  }

  // Handle ABV change - recalculate alcohol grams and calories
  onAbvChange(event: any, index: number): void {
    const newAbv = parseFloat(event.target.value) || 0;
    const item = this.foodDetails.foodItems[index];
    const baseData = this.allData[index][0];

    // Update ABV
    item.nutrition.alcoholAbv = newAbv;
    item.nutrition.isAlcoholic = newAbv > 0;

    const servingSize = parseFloat(item.serving?.size) || 0;
    const servingUnit = item.serving?.unit || 'grams';
    const qty = parseFloat(item.serving?.quantity) || 1;

    // Calculate per-serving alcohol grams (for 1 serving at original size)
    const originalSize = baseData.size || servingSize;
    const perServingAlcoholGrams = this.calculateAlcoholGramsFromAbv(originalSize, servingUnit, newAbv);

    // Update base reference so future quantity/size changes scale correctly
    baseData.alcoholGrams = perServingAlcoholGrams;

    // Calculate display value: per-serving × sizeScale × quantity
    const sizeScaleFactor = servingSize / originalSize;
    const displayAlcoholGrams = perServingAlcoholGrams * sizeScaleFactor * qty;
    item.nutrition.alcoholGrams = parseFloat(displayAlcoholGrams.toFixed(1));

    // Recalculate calories (includes alcohol: 7 cal/gram)
    const protein = parseFloat(item.nutrition.protein) || 0;
    const carbs = parseFloat(item.nutrition.carbs) || 0;
    const fat = parseFloat(item.nutrition.fat) || 0;
    item.nutrition.calories = parseFloat(
      this.calculateCaloriesFromMacros(protein, carbs, fat, item.nutrition.alcoholGrams).toFixed(1)
    );

    // Update total calories only
    let totalNutri = this.getTotalNutri(this.foodDetails.foodItems);
    this.foodDetails.total.calories = parseFloat(totalNutri[0].toFixed(1));
    this.setTotalValue();
  }

  // Toggle alcohol grams tooltip (read-only field explanation)
  toggleAlcoholGramsTooltip(event: MouseEvent, index: number): void {
    if (this.showAlcoholGramsTooltip === index) {
      this.showAlcoholGramsTooltip = null;
    } else {
      const target = event.currentTarget as HTMLElement;
      const rect = target.getBoundingClientRect();
      this.alcoholGramsTooltipStyle = {
        top: (rect.bottom + 8) + 'px',
        left: (rect.left + rect.width / 2) + 'px'
      };
      this.showAlcoholGramsTooltip = index;
    }
  }

  isBarcodeScan(): boolean {
    return this.foodDetails?.source === 'barcode_scan';
  }
}
